module.exports = __webpack_public_path__ + "static/12-1d9e9081e7fab3deeb88653274460414.jpg";